import Vue from 'vue';

const API_LANGUAGES__BASE = '/api/piivo/v1/languages';

export const I18N_BASE = '/i18n';

export default {
  /**
   * Gets the languages available to the app
   *
   * @returns {Promise} the api response or error
   */
  getAllLanguages() {
    return Vue.http.get(`${API_LANGUAGES__BASE}`);
  },

  /**
   *
   * @param {string} locale - the locale whose messages to retrieve
   * @returns {Promise}
   */
  getLocaleMessages(locale) {
    return Vue.http.get(`${I18N_BASE}/${locale}.json`);
  },
};
